(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.dashboard-exited-loans-table', [
    'pp.widgets-templates',
    'pp.controllers.dashboard-table'
]);

ngModule.component('ppDashboardExitedLoansTable', {
    templateUrl: 'widgets/_angular/dashboard-exited-loans-table/dashboard-exited-loans-table.tpl.html',
    bindings: {
        data: '<'
    },
    controllerAs: 'vm',
    controller: 'ppDashboardTableCtrl'
});
})(window, window.angular);